import MyButton from '../../../shared-components/button/Button';

interface FilterRoleInterface {
  activeTab: number;
  buttonList: {
    icon: JSX.Element;
    function: () => void;
  }[];
}
/**
 * Role Filter function component
 */
function MultiButtonGroup({ buttonList, activeTab }: FilterRoleInterface) {
  
  return (
    <div className="table-top-button-list">
      {buttonList.map((value, index) => (
        <div className="table-button-item">
          <MyButton
            label=""
            buttonType={index === activeTab ? 'primary-outline' : 'back'}
            onClickFunc={value.function}
            svgIcon={value.icon}
          />
        </div>
      ))}
    </div>
  );
}

export default MultiButtonGroup;
